import { EstacaoDeImpressao } from '@/models/EstacaoDeImpressao'
import { AxiosRequestConfig } from 'axios'
import { Inject } from 'inversify-props'
import type { EstacaoDeImpressaoServiceAdapter } from '@/usecases'

export class EstacaoDeImpressaoUseCase {
	@Inject('EstacaoDeImpressaoServiceAdapter')
	private estacaoDeImpressaoService!: EstacaoDeImpressaoServiceAdapter

	createEstacaoDeImpressao = async (estacao: EstacaoDeImpressao): Promise<EstacaoDeImpressao> =>
		await this.estacaoDeImpressaoService.createEstacaoDeImpressao(estacao)

	updateEstacaoDeImpressao = async (estacaoId: string, estacao: EstacaoDeImpressao): Promise<EstacaoDeImpressao> =>
		await this.estacaoDeImpressaoService.updateEstacaoDeImpressao(estacaoId, estacao)

	findEstacoesDeImpressaoPorLoja = async (lojaId: string, apenasAtivas?: boolean, config?: AxiosRequestConfig): Promise<EstacaoDeImpressao[]> =>
		await this.estacaoDeImpressaoService.findEstacoesDeImpressaoPorLoja(lojaId, apenasAtivas, config)

	findEstacaoDeImpressaoById = async (estacaoId: string, config?: AxiosRequestConfig): Promise<EstacaoDeImpressao> =>
		await this.estacaoDeImpressaoService.findEstacaoDeImpressaoById(estacaoId, config)

	deleteEstacaoDeImpressao = async (estacaoId: string, config?: AxiosRequestConfig): Promise<void> =>
		await this.estacaoDeImpressaoService.deleteEstacaoDeImpressao(estacaoId, config)
}
